module.exports = "/images/vendor/flag-icon-css/flags/4x3/km.svg?9b06043d7f9a227bc63532af67999125";